<template>
  <div style="background: #f9f9f9">
    <div class="userCenter flex">
      <!-- 左边列表 -->
      <div class="userCenter_left">
        <div
          class="userCenter_left_box"
          v-for="(items, index) in userServeList"
          :key="index"
        >
          <p class="userCenter_left_title">{{ items.title }}</p>
          <p
            v-for="(itemsName, indexs) in items.titleMess"
            :key="indexs"
            @click="getUserMessage(itemsName.id)"
            :class="userServeId === itemsName.id ? 'active_p' : ''"
          >
            {{ itemsName.name }}
          </p>
        </div>
      </div>
      <!-- 右边信息 -->
      <div class="userCenter_right" v-show="userServeId === '00'">
        <h4>基础信息</h4>
        <div class="flex userCenter_right_box">
          <!-- 上传头像 -->
          <div class="right_boxImg">
            <el-upload
              action="/service-center/upload/file/single"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :show-file-list="false"
            >
              <img
                v-if="!userInfoAvatar"
                src="../../../assets/users.png"
                alt=""
              />
              <img v-if="userInfoAvatar" :src="userInfoAvatar" alt="" />
              <p>修改头像</p>
            </el-upload>
          </div>

          <div class="userCenter_right_mess">
            <p class="userCenter_right_name">{{ isUsermessage.name }}</p>
            <div class="flex userCenter_right_con">
              <div
                class="flex userCenter_right_conN"
                v-if="userDetail.identity !== 'STAFF'"
              >
                <p class="conName">认证信息</p>
                <p
                  class="userMessage"
                  v-if="
                    userDetail.identity === 'PERSONAL' ||
                      userDetail.identity === 'ENTERPRISE'
                  "
                >
                  {{
                    userDetail.identity === "PERSONAL"
                      ? "个人实名认证"
                      : userDetail.identity === "ENTERPRISE"
                      ? "企业认证"
                      : ""
                  }}
                </p>
                <p
                  class="userMessage"
                  style="background: #c0c4cc;color: #f9f9f9;"
                  v-if="userDetail.identity === 'ANONYMOUS'"
                >
                  未认证
                </p>
                <p class="userMessMore" @click="toCertificationDetails">
                  {{ userDetail.identity === "ANONYMOUS" ? "去认证" : "详情" }}
                </p>
              </div>
              <div class="flex">
                <p class="conName">登录账户</p>
                <p class="conMessage">{{ isUsermessage.tel }}</p>
              </div>
            </div>
            <div class="flex userCenter_right_con">
              <div class="flex userCenter_right_conN">
                <p class="conName" style="margin-right: 10px;">
                  昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称
                </p>
                <!-- <el-input class="conMessage1" size="mini" v-model="usermessageName" placeholder="请输入昵称"
                                @blur="!usermessageName?usermessageName = isUsermessage.name:usermessageName"></el-input> -->
                <!--<p class="conMessage1">{{ isUsermessage.name }}</p>-->
                <!-- <p class="userMessMore" @click="editUserName">
                                    <i class="el-icon-edit-outline"></i> 修改
                                </p> -->
                <div v-show="addShow" class="checkName">
                  <span class="conMessage1">{{ usermessageName }}</span>
                  <!--<p class="conMessage1">{{ isUsermessage.name }}</p>-->
                  <p class="userMessMore">
                    <i class="el-icon-edit-outline"></i>
                    <span @click="addShow = false">修改</span>
                  </p>
                </div>
                <div v-show="!addShow" class="checkName">
                  <el-input
                    class="conMessage1"
                    size="mini"
                    v-model="usermessageName"
                    placeholder="请输入昵称"
                    @blur="
                      !usermessageName
                        ? (usermessageName = isUsermessage.name)
                        : usermessageName
                    "
                  ></el-input>
                  <p class="userMessMore" @click="editUserName">
                    <!-- <i class="el-icon-edit-outline"></i> -->
                    保存
                  </p>
                </div>
              </div>
              <div class="flex">
                <p class="conName">注册时间</p>
                <p class="conMessage">
                  {{ $date.formatDate(isUsermessage.createdDate) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            userDetail.identity === 'ENTERPRISE' ||
              userDetail.identity === 'STAFF'
          "
          style="display:flex"
          class="userCenter_right_bottom"
        >
          <div
            class="flex userCenter_right_con"
            v-for="(item, index) in softwareTypeList"
            :key="index"
          >
            <span
              @click="showApp(index, item.uuid)"
              :class="companyIndex == index ? 'successChoose' : 'releaseChoose'"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div
          v-if="
            userDetail.identity === 'ENTERPRISE' ||
              userDetail.identity === 'STAFF'
          "
          style="display:flex"
          class="userCenter_right_img"
        >
          <div
            class="flex userCenter_right_con"
            v-for="(items, index) in allAppList"
            :key="index"
          >
            <div class="name">
              <a :href="items.deployUrl" target="_blank">
                <img :src="items.logo" alt="" />
                <div class="infoContent">
                  <div class="infoName">{{ items.applicationName }}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 实名认证 -->
      <CertificationCenter
        ref="certificationCenterRef"
        v-show="userServeId === '10'"
      />
      <!-- 企业认证 -->
      <EnterCertification
        ref="EnterpriseCertificationRef"
        v-show="userServeId === '11'"
      />
      <!--安全设置-->
      <SecuritySettings
        ref="SecuritySettingsRef"
        v-show="userServeId === '01'"
      ></SecuritySettings>
      <!--组织架构-->
      <OrganizationalStructure
        ref="OrganizationalStructureRef"
        v-show="userServeId === '20'"
      ></OrganizationalStructure>
      <!--成员管理-->
      <MemberManage
        ref="MemberManageRef"
        v-show="userServeId === '21'"
      ></MemberManage>
      <!--企业应用-->
      <ApplicationManage
        ref="ApplicationManageRef"
        v-show="userServeId === '30'"
      ></ApplicationManage>
      <!--软件应用-->
      <SoftwareApplication
        ref="SoftwareApplicationRef"
        v-show="userServeId === '31'"
      ></SoftwareApplication>
      <!--软件应用-->
      <!--<SoftwareCollection reg="SoftwareCollectionRef" v-show="userServeId === '32'"></SoftwareCollection>-->
    </div>
  </div>
</template>

<script>
import {
  getNewcurrent,
  editUserInfo,
  getApplicationList,
  getIdentity,
  getAllApplicationList,
  queryAllSoftwareOrderDetailList,
  getSoftwareTypeList,
} from "../../../utils/interface";
import CertificationCenter from "../certificationCenter/index";
import { mapMutations, mapState } from "vuex";
import EnterCertification from "../certificationCenter/enterCertification";
import SecuritySettings from "../securitySettings";
import ApplicationManage from "../applicationManage";
import SoftwareApplication from "../softwareApplication";
// import SoftwareCollection from "../softwareCollection"
import MemberManage from "../memberManage";
import OrganizationalStructure from "../organizationalStructure";
export default {
  //   用户中心
  name: "userCenter",
  components: {
    CertificationCenter,
    EnterCertification,
    SecuritySettings,
    ApplicationManage,
    SoftwareApplication,
    // SoftwareCollection,
    MemberManage,
    OrganizationalStructure,
  },
  data() {
    return {
      companyIndex: "0",
      addShow: true,
      userServeList: [],
      applicationList: [],
      allAppList: [],
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
      },
      userMenu: {
        title: "用户服务",
        titleMess: [
          {
            id: "00",
            name: "用户中心",
          },
          {
            id: "01",
            name: "安全设置",
          },
        ],
      },
      attestationmenu: {
        title: "认证中心",
        titleMess: [
          {
            id: "10",
            name: "实名认证",
          },
          {
            id: "11",
            name: "企业认证",
          },
        ],
      },
      enterpriseMenu: {
        title: "企业管理",
        titleMess: [
          {
            id: "20",
            name: "组织架构",
          },
          {
            id: "21",
            name: "成员管理",
          },
        ],
      },
      softwareMenu: {
        title: "应用管理",
        titleMess: [
          {
            id: "30",
            name: "企业应用",
          },
          {
            id: "31",
            name: "软件应用",
          },
          // {
          //     id: '32',
          //     name: "收藏软件",
          // },
        ],
      },
      userServeIndex: "0",
      userServeIndex2: "0",
      userServeId: "00",
      // 上传头像
      imageUrl: require("../../../assets/noneImg.png"),
      userInfo: {
        avatar: require("../../../assets/noneImg.png"),
      },
      userInfoAvatar: "",
      usermessageName: "",
      userDetail: {},
      identityStatus: false,
      softwareTypeList: [],
    };
  },
  computed: {
    ...mapState({
      isUsermessage: "isUsermessage",
      isLogin: "isLogin",
    }),
  },
  mounted() {
    // console.log("jjj", this.isUsermessage);
    if (!this.isLogin) {
      // this.$alert("请先登录", {
      //     confirmButtonText: "确定",
      //     callback: (action) => {
      //         this.$router.push('/login')
      //     },
      // });
      // 跳转到首页
      this.$router.push("/login");
    }
    // console.log(this.$route.params)
    this.userServeId = this.$route.params.userServeId;
    // this.userServeId = window.sessionStorage.getItem("userServeId") ? window.sessionStorage.getItem("userServeId"): '00'
    this.userServeList = [];
    this.userServeList.push(this.userMenu);
    this.userServeList.push(this.attestationmenu);
    this.getUserMessage(this.userServeId);
  },
  created() {
    // console.log(this.$store.state.status,2222222222222222)
    this.getUserInfo();
    //this.getUserMessage('00');
  },
  methods: {
    ...mapMutations(["isStorageUsermessage", "isuserServeVuex"]),
    getUserMessage(id) {
      this.userServeId = id;
      // this.userServeId = this.$store.state.status;
      // console.log(this.$store.state.status,111)
      window.sessionStorage.setItem("userServeId", id);
      if (this.userServeId === "10") {
        this.$refs.certificationCenterRef.getUserCredentials();
      }
      if (this.userServeId === "11") {
        this.$refs.EnterpriseCertificationRef.getEnterpriseUserCredentials();
      }
      if (this.userServeId === "01") {
        this.$refs.SecuritySettingsRef.init();
      }
      if (this.userServeId === "00") {
        this.softwareTypeList = [];
        this.allAppList = [];
        getSoftwareTypeList({ current: 1, pageSize: 100 }).then((res) => {
          this.softwareTypeList.push({ name: "全部", uuid: "" });
          if (res != null && res.list != null && res.list.length > 0) {
            res.list.forEach((item, index) => {
              this.softwareTypeList.push({
                name: item.typeName,
                uuid: item.uuid,
              });
            });
          }
        });
        getAllApplicationList({ type: 1352 }).then((res) => {
          if (res != null && res.length > 0) {
            res.forEach((item, index) => {
              this.allAppList.push({
                logo: item.logoUrl,
                deployUrl: item.deployUrl,
                applicationName: item.applicationName,
                type: item.type,
                uuid: item.uuid,
              });
            });
          }
          let params = {
            isBuy: true,
            state: 2000,
          };
          queryAllSoftwareOrderDetailList(params).then((res1) => {
            if (res1 != null && res1.length > 0) {
              res1.forEach((item, index) => {
                this.allAppList.push({
                  logo: item.softwareLogo,
                  deployUrl: item.deployUrl,
                  applicationName: item.softwareName,
                  type: 1351,
                  uuid: item.uuid,
                });
              });
            }
          });
        });
      }
      if (this.userServeId === "20") {
        this.$refs.OrganizationalStructureRef.init();
      }
      if (this.userServeId === "21") {
        this.$refs.MemberManageRef.init();
      }
      if (this.userServeId === "30") {
        this.$refs.ApplicationManageRef.init();
      }
      if (this.userServeId === "31") {
        this.$refs.SoftwareApplicationRef.init();
      }
    },
    getApplication() {
      let param = {
        current: 1,
        pageSize: 20,
        type: 1352,
      };
      this.loading = true;
      getApplicationList(param).then((res) => {
        this.applicationList = res.list;
        this.total = res.total;
        this.loading = false;
      });
    },
    // 上传头像
    handUserimg() {
      this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile(e) {
      //获取当前点击事件的target元素对其进行兼容
      let $target = e.target || e.srcElement;
      //   取第一个元素
      let file = $target.files[0];
      /**
       * 使用FileReader对象，
       * web应用程序可以异步的读取存储在用户计算机上的文件(或者原始数据缓冲)内容，
       * 可以使用File对象或者Blob对象来指定所要处理的文件或数据。
       *  */
      var reader = new FileReader(); // //读取本地文件，以gbk编码方式输出
      reader.onload = (data) => {
        //成功读取后
        // console.log(data);
        let res = data.target || data.srcElement;
        // //读取完毕后输出结果
        this.userInfo.avatar = res.result;
      };
      reader.readAsDataURL(file);
    },
    // 点击跳转至用户详情
    toCertificationDetails() {
      if (
        this.userDetail.identity === "PERSONAL" ||
        this.userDetail.identity === "ANONYMOUS"
      ) {
        this.userServeId = "10";
        this.$refs.certificationCenterRef.getUserCredentials();
      } else if (
        this.userDetail.identity === "ENTERPRISE" ||
        this.userDetail.identity === "ANONYMOUS"
      ) {
        this.userServeId = "11";
        this.$refs.EnterpriseCertificationRef.getEnterpriseUserCredentials();
      }
      // if(this.userDetail.identity==='ANONYMOUS'){
      //      this.userServeId = '10'
      //     this.$refs.certificationCenterRef.getUserCredentials()
      // }
    },
    getUserInfo() {
      getIdentity().then((res) => {
        this.identityStatus = res.success;
      });
      getNewcurrent()
        .then((res) => {
          this.userDetail = res;
          this.isStorageUsermessage(res);
          this.userInfoAvatar = res.headUrl ? res.headUrl : "";
          this.usermessageName = res.name ? res.name : "";
          this.userServeList = [];
          if (res.identity == "ANONYMOUS") {
            this.userServeList.push(this.userMenu);
            this.userServeList.push(this.attestationmenu);
          }
          if (res.identity == "PERSONAL") {
            this.userServeList.push(this.userMenu);
            this.userServeList.push(this.attestationmenu);
          }
          if (res.identity == "ENTERPRISE") {
            this.userServeList.push(this.userMenu);
            this.userServeList.push({
              title: "认证中心",
              titleMess: [
                {
                  id: "11",
                  name: "企业认证",
                },
              ],
            });
            this.userServeList.push(this.enterpriseMenu);
            this.userServeList.push(this.softwareMenu);
            this.getApplication();
          }
          if (res.identity == "STAFF") {
            this.userServeList.push(this.userMenu);
            // this.userServeList.push(this.attestationmenu);
            //this.userServeList.push(this.enterpriseMenu);
            // this.userServeList.push(this.softwareMenu);
            this.getApplication();
          }
          // this.getUserMessage(this.userServeId)
        })
        .catch((err) => {});
    },
    handleAvatarSuccess(obj, fileList) {
      let data = {
        headUrl: obj.url,
      };
      editUserInfo(data).then((res) => {
        if (res.success) {
          this.getUserInfo();
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
          });
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      let fileTypes = [
        ".jpg",
        ".png",
        ".jpeg",
        ".bmp",
        ".JPG",
        ".PNG",
        ".JPEG",
        ".BMP",
      ];
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      let fileIndex = fileTypes.indexOf(fileTypeName);
      if (fileIndex === -1) {
        this.$alert("只能上传图片格式", "提示", {
          confirmButtonText: "确定",
        });
      }
      return fileIndex !== -1;
    },
    // 修改昵称
    editUserName() {
      if (this.usermessageName) {
        let data = {
          name: this.usermessageName,
        };
        editUserInfo(data).then((res) => {
          if (res.success) {
            this.getUserInfo();
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定",
            });
          }
        });
      } else {
        this.$alert("昵称不能为空", "提示", {
          confirmButtonText: "确定",
        });
      }
      this.addShow = true;
    },
    showApp(i, typeUuid) {
      this.allAppList = [];
      getAllApplicationList({ type: 1352, softwareType: typeUuid }).then(
        (res) => {
          if (res != null && res.length > 0) {
            res.forEach((item, index) => {
              this.allAppList.push({
                logo: item.logoUrl,
                deployUrl: item.deployUrl,
                applicationName: item.applicationName,
                type: item.type,
                uuid: item.uuid,
              });
            });
          }
          let params = {
            isBuy: true,
            state: 2000,
            softwareType: typeUuid,
          };
          queryAllSoftwareOrderDetailList(params).then((res1) => {
            if (res1 != null && res1.length > 0) {
              res1.forEach((item, index) => {
                this.allAppList.push({
                  logo: item.softwareLogo,
                  deployUrl: item.deployUrl,
                  applicationName: item.softwareName,
                  type: 1351,
                  uuid: item.uuid,
                });
              });
            }
          });
        }
      );
      this.companyIndex = i;
    },
  },
};
</script>

<style scoped lang="less">
.checkName {
  display: flex;
  align-items: center;
}
.blue {
  color: #1181ff;
}

.red {
  color: #d60000;
}

.userCenter {
  width: 1200px;
  margin: 0 auto;
  padding: 70px 0;

  .userCenter_left {
    width: 200px;
    text-align: center;
    margin-right: 34px;

    .userCenter_left_box {
      background: #fff;
      border-radius: 5px;
      font-size: 14px;
      margin-bottom: 10px;
    }

    p {
      height: 40px;
      line-height: 40px;
      border-bottom: 2px solid #f9f9f9;
      cursor: pointer;
    }

    .active_p {
      background: #e2efff;
    }

    .userCenter_left_title {
      cursor: default;
      color: #fff;
      border-radius: 5px 5px 0 0;
      background: #157efb;
      height: 50px;
      line-height: 50px;
      font-size: 17px;
    }
  }

  .userCenter_right {
    width: 966px;
    background: #fff;

    h4 {
      color: #157efb;
      padding: 20px 18px;
      border-bottom: 2px solid #f9f9f9;
    }
    .userCenter_right_bottom {
      padding-left: 18px;
      height: 40px;
      align-items: center;
      justify-content: space-between;
      .userCenter_right_con {
        //  margin-right: 9px;
        span {
          padding: 5px 10px;

          cursor: pointer;
        }
      }
      .relaseChoose {
        display: inline-block;
        margin-right: 9px;
        cursor: pointer;
        font-size: 16px;
      }
      .successChoose {
        border-radius: 5px;
        background-color: #bbd9fe;
        // color: #157efb;
        color: #157efb;
      }
    }

    .name {
      width: 150px;
      text-align: center;
      // margin-right: 70px;
      margin-top: 30px;
    }

    .userCenter_right_con:nth-of-type(4n) {
      margin-right: 0;
    }

    .userCenter_right_img {
      width: 965px;
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .userCenter_right_con {
        margin-right: 70px;
      }
      // padding-left: 10px;
      .infoName {
        font-size: 16px;
      }
      img {
        width: 50px;
        height: 50px;
        // margin-right: 30px;
        border-radius: 10px;
      }
      .infoContent {
        width: 150px;
        margin-top: 10px;
        text-align: center;
        color: #595959;
      }
    }
    .userCenter_right_box {
      padding: 30px 18px;
      // 上传头像
      .right_boxImg {
        width: 100px;
        height: 100px;
        position: relative;

        img {
          // width: 100%;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }

        .hiddenInput {
          display: none;
        }

        p {
          display: none;
          position: absolute;
          bottom: 5px;
          width: 100%;
          font-size: 12px;
          background: rgba(255, 255, 255, 0.68);
          text-align: center;
          color: #777777;
        }
      }
      .right_boxImg:hover p {
        display: block;
        cursor: pointer;
      }
      .userCenter_right_mess {
        margin-left: 20px;

        .userCenter_right_name {
        }

        .userCenter_right_con {
          color: #595959;
          font-size: 14px;
          margin-top: 18px;

          .userCenter_right_conN {
            margin-right: 70px;
            align-items: center;
            width: 230px;
            // justify-content: space-between;
          }

          .conName {
            margin-right: 16px;
          }

          .userMessage {
            font-size: 12px;
            background: #bbd9fe;
            color: #157efb;
            padding: 4px 0;
            margin-right: 16px;
            width: 101px;
            text-align: center;
          }

          .userMessMore {
            font-size: 12px;
            color: #157efb;
            cursor: pointer;
            text-align: right;
            white-space: nowrap;
          }

          .conMessage {
            font-size: 13px;
          }
          .conMessage1 {
            font-size: 12px;
            margin-right: 16px;
            width: 102px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/userCenter/index.vue